import { Component, Inject, OnInit, Input } from '@angular/core';
import { HeaderTemplateData } from '../dialog-data.interface';


@Component({
    selector: 'dialog-header',
    templateUrl: 'dialog-header.html',
    styleUrls: ['dialog-header.scss']
})
export class DialogHeader implements OnInit {
    @Input() data: HeaderTemplateData;
    header:HeaderTemplateData;
    constructor(){
    }

    ngOnInit() {
        this.header=this.data;
        this.header.title.leftTopTitle.title.text
    }
}
